// extracted by mini-css-extract-plugin
export default {"nav":"testimonialnav_nav__xrYvh"};